import { Box, Divider, Grid, Typography, Link as MuiLink } from '@mui/material'

import moment from 'moment'
import InfoBox from './InfoBox'
import { planMessage } from './utils'
import OrderItem from './OrderItem'
import { HighlightText, Logger, toDollars } from '@wolfdanepug/common-react'
import theme from '../../theme'

const OrderNote = () => {
	return (
		<Box sx={{ p: 4, background: (theme as any).app.background, borderRadius: 2 }}>
			<Typography variant="h6" textAlign={'center'} mb={3} fontSize={'.9rem'}>
				Manage your subscription anytime
				<br />
				from your account.
			</Typography>
			<Typography variant="body2" fontSize={'.8rem'}>
				Wolf Dane Pug is an{' '}
				<Box component="span" sx={{ fontWeight: 700 }}>
					auto-renewing subscription
				</Box>{' '}
				with no long-term commitment. By starting your first gourmet box, you agree to our{' '}
				<MuiLink component={'a'} href="/terms" target="_blank">
					Terms of Use
				</MuiLink>
				. You can cancel unprocessed orders at any time.
			</Typography>
		</Box>
	)
}

const TextRow = ({ label, value, sx = {} }: any) => (
	<>
		<Grid item xs={9}>
			<Typography variant="body2" sx={sx.label}>
				{label}
			</Typography>
		</Grid>
		<Grid item xs={3} textAlign={'right'}>
			<Typography variant="body2" sx={sx.value}>
				{value}
			</Typography>
		</Grid>
	</>
)

const renderDiscountText = (discount: any) => {
	return discount
		? discount?.percent
			? `With ${discount?.percent}% first 30 days discount`
			: discount?.amount
				? `With ${discount?.amount} off)`
				: ''
		: ''
}

export default function OrderSummary({ cart, coupon, total }: any) {
	const discountText = renderDiscountText(coupon)
	const firstShipDate = moment().add(1, 'week').startOf('week').startOf('day').format('MMMM Do')
	const subtotalStyles = coupon ? styles.discounted : {}

	const handleDeleteRequest = (item: any) => {
		Logger.log('Delete item', item)
	}

	return (
		<Grid container spacing={2}>
			<Grid item md={12}>
				<Typography variant="h4">Order Summary</Typography>
			</Grid>
			<InfoBox header="Your plan">{planMessage(cart)}</InfoBox>

			<InfoBox header="Your first gourmet box">
				We'll ship your delicious first gourmet box the{' '}
				<HighlightText>week of {firstShipDate}</HighlightText>.
			</InfoBox>

			<InfoBox header="After the first gourmet box">
				Your selected plan will be billed and shipped <HighlightText>every 11 days</HighlightText>.
			</InfoBox>

			<Grid item md={12}>
				<Box sx={{ pt: 3, pb: 3 }}>
					<Grid container spacing={2}>
						{cart?.items.map((item: any) => (
							<OrderItem
								key={`cart-item${item.id}`}
								item={item}
								// deleteEnabled
								onClick={() => handleDeleteRequest(item)}
							/>
						))}
						<Grid item xs={12}>
							<Divider />
						</Grid>
						<TextRow
							label="Gourmet Fresh Subtotal"
							value={`$ ${toDollars(cart?.subtotal)}`}
							sx={{ value: subtotalStyles }}
						/>

						{discountText && (
							<TextRow
								label={discountText}
								value={`$ ${toDollars(total)}`}
								sx={{ label: styles.green, value: styles.green }}
							/>
						)}
						<TextRow label="Shipping" value="Free" />
						<TextRow label="Tax" value="$ 0.00" />
						<Grid item xs={12}>
							<Divider />
						</Grid>
						<TextRow label="Total Order Price" value={`$ ${toDollars(total)}`} />
					</Grid>
				</Box>
			</Grid>
			<Grid item md={12}>
				<OrderNote />
			</Grid>
		</Grid>
	)
}

const styles = {
	discounted: {
		textDecoration: 'line-through'
	},
	green: {
		color: 'green'
	}
}
